import { Grid } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { Button, DatePicker, Section, SmSpace } from 'm2m.components';
import { Moment } from 'moment';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { DateViewModel } from 'common/genericTypes';
import { isValid } from 'utils/date';
import moment from 'moment';
import { DatePickerBusinessDay } from 'components/DatePickerBussinessDay';

interface DatesSectionProps {
  title: string;
  label: string;
  onUpdateDates: (dateViewModels: DateViewModel[]) => void;
  dates: Moment[];
  required?: boolean;
  maxDate?: Moment;
  minDate?: Moment;
  error?: boolean;
}

export const DatesSection: React.FC<DatesSectionProps> = (props) => {
  const [newDate, setNewDate] = React.useState<Moment>();
  const [dates, setDates] = React.useState<DateViewModel[]>(
    props.dates?.map((date) => ({
      id: uuidv4(),
      date,
    })) ?? []
  );

  const handleAddClick = () => {
    if (newDate) {
      const newDates = [...dates].concat({ id: uuidv4(), date: newDate });
      setDates(newDates);
      setNewDate(undefined);
      props.onUpdateDates(newDates);
    }
  };

  const handleDateChange = (id: string) => (updatedDate: Moment | null) => {
    if (!updatedDate) return;

    const updatedDates = dates.map((dateViewModel) => ({
      id: dateViewModel.id,
      date: id === dateViewModel.id ? updatedDate : dateViewModel.date,
    }));
    setDates(updatedDates);
    if (isValid(updatedDate)) {
      props.onUpdateDates(updatedDates);
    }
  };

  const handleRemoveClick = (id: string) => {
    const newDates = dates.filter((date) => date.id !== id);
    setDates(newDates);
    props.onUpdateDates(newDates);
  };

  React.useEffect(() => {
    if (props.dates) {
      setDates(
        props.dates?.map((date) => ({
          id: uuidv4(),
          date,
        }))
      );
    }
  }, [props]);

  return (
    <Section title={props.title}>
      <Grid container spacing={2} style={{ width: '100%' }}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs>
              <DatePickerBusinessDay
                label={props.label}
                value={newDate ?? null}
                onChange={(value) => setNewDate(value ?? undefined)}
                required={props.required}
                minDate={props.minDate}
                maxDate={props.maxDate}
                error={props.error}
                keyValue="newDate"
                validateBusinessDay
              />
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                style={{ minWidth: '0', padding: '5px', width: '45px', height: '45px', marginTop: '5px' }}
                disabled={
                  !isValid(newDate) ||
                  (moment(newDate)?.isAfter(props.maxDate, 'day') ?? true) ||
                  (moment(newDate)?.isBefore(props.minDate, 'day') ?? true)
                }
                onClick={handleAddClick}
              >
                <AddIcon />
              </Button>
            </Grid>
          </Grid>
          {dates?.map((dateViewModel) => (
            <Grid container spacing={2} key={dateViewModel.id}>
              <Grid item xs>
                <SmSpace />
                <DatePickerBusinessDay
                  required
                  label={props.label}
                  value={dateViewModel.date}
                  onChange={handleDateChange(dateViewModel.id)}
                  minDate={props.minDate}
                  maxDate={props.maxDate}
                  keyValue={`incorporacaoJuros-${dateViewModel.id}`}
                  validateBusinessDay
                />
              </Grid>
              <Grid item>
                <SmSpace />
                <Button
                  variant="contained"
                  color="error"
                  style={{ minWidth: '0', padding: '5px', width: '45px', height: '45px', marginTop: '5px' }}
                  onClick={() => handleRemoveClick(dateViewModel.id)}
                >
                  <RemoveIcon />
                </Button>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Section>
  );
};
